import { useActionDraftMergeRefine } from "hook/draft/dialog/useActionDraftMerge";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setDraftDialogMerge } from "store/bailiff/draft/dialog/draft_dialog.action";
//
//component
//redux
//selector
//actions
export const TriggerMerge = () => {
  // -------------------------- VAR ----------------------------
  const { data } = useActionDraftMergeRefine();
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (data) {
      dispatch(setDraftDialogMerge(data));
    }
  }, [dispatch, data]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerMerge;
